import { SxProps, Theme } from '@mui/material';
import { CSSProperties, useCallback, useState } from 'react';
import { LoadingIndicator } from './LoadingIndicator';

interface ImageProps {
  src: string;
  style?: CSSProperties;
  loaderSxProps?: SxProps<Theme>;
}

export const ImageWithLoader = (props: ImageProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = useCallback(() => {
    setImageLoaded(true);
  }, []);

  return (
    <>
      {!imageLoaded && <LoadingIndicator sx={props.loaderSxProps ?? {}} />}
      <img style={props.style ?? {}} src={props.src} onLoad={handleImageLoad} />
    </>
  );
};
